package com.hyperether.goodjob.util

import androidx.compose.ui.graphics.painter.Painter
import com.hyperether.goodjob.repository.remote.model.FileObject

data class FileEntity(
    var fileId: String? = null,
    var jobId: String? = null,
    var fileObject: FileObject? = null,
    var documentType: DocumentType? = null,
    var uploadStatus: UploadStatus? = null,
    var painter: Painter? = null,
    var path: String? = null
)
